import React from 'react';

const ScheduleIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      width={width}
    >
      <rect x="1.4" y="4.2" width="21.2" height="18.5" rx="2.4" ry="2.4" fill={fillColor} />
      <line x1="1.8" y1="10.9" x2="22.2" y2="10.9" />
      <line x1="7.6" y1="1.3" x2="7.6" y2="7" />
      <line x1="16.2" y1="1.3" x2="16.2" y2="7" />
    </svg>
  );
};

export default ScheduleIcon;
